import React from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { Dialog } from '@mui/material';
import BaseButton from '../../../../components/BaseButton';

export const CancelEnvelopeFolderDecisionDialog = (props) => {

    const {open, setOpen, handleCancel} = props

    return (
        <Dialog
            open={open}
            onClose={()=> setOpen(false)}
        >
            <div className="dialog__row-container" style={{justifyContent: 'space-between'}}>
                <div style={{width: '31px'}}></div>
                <h2>Atenção!</h2>
                <IconButton
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon />
                </IconButton>
            </div>
            <div className="dialog__column-container">
                <h3 style={{marginBottom: '10px'}}>Tem certeza que deseja cancelar esta pasta? Todos os envelopes vinculados que ainda não foram finalizados também serão cancelados.</h3>
                <BaseButton
                    label="CANCELAR PASTA"
                    className="btn__container--center btn btn--red btn--animated"
                    onClick={() => handleCancel()}
                />
            </div>
        </Dialog>
    );
}